module.exports = __webpack_public_path__ + "static/media/linked-account.9c572d8a.jpg";